import { useEffect, useState } from "react";
import { registerSessionHandler } from "../api/sessionGuard";
import ErrorScreen from "../components/Alerts/ErrorScreen";
import { useLocation } from "react-router-dom";
import ModalBase from "../components/Popups/ModalBase";
import PopupHeader from "../components/Popups/PopupHeader"

export default function SessionGuardProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState<string>("ERR_NETWORK");
  const location = useLocation();

  useEffect(() => {
    registerSessionHandler(({ code }) => {
      if (open) return;              // respect snooze
      if (location.pathname.startsWith("/login")) return;
      setCode(code);
      setOpen(true);
    });
  }, [open, location.pathname]);


  return (
    <>
      {children}
      <ModalBase
        open={open}
        modalId="session-expired"
      >
        <div className={`bg-white rounded-lg w-[400px] mx-auto`}>
            <PopupHeader
                label=""
                hasOutline={true}
                closeFn={()=>{setOpen(false)}}
            />  
            <ErrorScreen errCode={code} isModal setModalOpen={setOpen} />
        </div>
      </ModalBase>
    </>
  );
}
